// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--2dTcg";
export var infoBoxContainer = "styles-module--infoBoxContainer--X8tPY";